import { WebhookType } from './webhook-type.enum';
var WebhookBuilder = /** @class */ (function () {
    function WebhookBuilder() {
        this.webhook = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'Bob Webhooks',
            url: 'http://www.bobwebhooks.com',
            type: WebhookType.TICKET_CREATED
        };
    }
    WebhookBuilder.prototype.withId = function (id) {
        this.webhook.id = id;
        return this;
    };
    WebhookBuilder.prototype.withUrl = function (url) {
        this.webhook.url = url;
        return this;
    };
    WebhookBuilder.prototype.withName = function (name) {
        this.webhook.name = name;
        return this;
    };
    WebhookBuilder.prototype.withType = function (type) {
        this.webhook.type = type;
        return this;
    };
    WebhookBuilder.prototype.build = function () {
        return this.webhook;
    };
    return WebhookBuilder;
}());
export { WebhookBuilder };
//# sourceMappingURL=webhook.builder.js.map